import React, { useEffect, useState } from "react";
import {
    CustomAntCheckbox,
    CustomDeleteButton,
    DeleteIconArea,
    SettingsValue,
    TickerItemDiv,
    NameSpan,
} from "./CommonSettingsBlockStyles";
import { UnderlinedInput } from "components/Inputs/inputsStyles";
import { useAppSelector } from "hooks/redux";

import { Select, Tooltip } from "antd";
import { BasedSelect } from "components/Selects/BasedSelect";

export const CommonSettingsItem = ({
    name,
    currentValue,
    isInput = false,
    isCheckbox = false,
    onChange,
    onRemove,
    has_change,
    isSavingError,
    isInputError,
    placeholder,
    configCode,
    disabled,
}: any) => {
    const [isEdited, setIsEdited] = useState(false);
    const [isHasSavingError, setIsHasSavingError] = useState(false);
    const [inputValue, setInputValue] = useState(currentValue);
    const editMode = useAppSelector((state) => state.settings.editMode);
    const { Option } = Select;
    const description = useAppSelector(
        (state) =>
            state.settings.configParams[configCode]?.descriptions?.[name] || "",
    );
    const showDescriptions = useAppSelector(
        (state) => state.settings.showDescriptions,
    );
    const availableSCIds = useAppSelector(
        (state) => state.settings.availableSCIds,
    );
    const scSchedules = useAppSelector((state) => state.settings.scSchedules);
    const middlewareInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.currentTarget.value;

        setInputValue(newValue);
        onChange(newValue);

        setIsEdited(true);
        setIsHasSavingError(false);
    };

    useEffect(() => {
        setIsHasSavingError(isSavingError);
    }, [isSavingError]);

    useEffect(() => {
        setInputValue(currentValue ?? "");
    }, [currentValue]);

    const resetConfigsCounter = useAppSelector(
        (store) => store.settings.resetConfigsCounter,
    );

    useEffect(() => {
        setIsEdited(false);
    }, [resetConfigsCounter]);
    const handleSelectChange = (value: string) => {
        onChange(value);
        setIsEdited(true);
        setIsHasSavingError(false);
    };

    const renderInput = () => {
        const rawName = name?.split(" ")?.[0];

        // Если SheduleID — рендерим Select
        if (rawName === "SheduleID" || rawName === "ScheduleID") {
            return (
                <BasedSelect
                    value={currentValue || undefined}
                    onChange={handleSelectChange}
                    disabled={disabled}
                    placeholder={placeholder || "Выберите значение"}
                    style={{
                        width: "100%",
                        minWidth: 100,
                        borderBottom: "1px solid #d9d9d9",
                        borderRadius: 0,
                        boxShadow: "none",
                    }}
                    dropdownStyle={{ zIndex: 1050 }}
                >
                    {(scSchedules || []).map((schedule) => (
                        <Option key={schedule.id} value={schedule.id}>
                            {schedule.id}: {schedule.start_time}-
                            {schedule.end_time}
                        </Option>
                    ))}
                </BasedSelect>
            );
        }

        if (isInput) {
            return (
                <UnderlinedInput
                    isEdited={isEdited}
                    isError={(isEdited && isHasSavingError) || isInputError}
                    onChange={(e) => middlewareInputChange(e)}
                    name={name}
                    disabled={disabled}
                    type="text"
                    value={inputValue}
                    placeholder={placeholder ? placeholder : ""}
                    style={{ cursor: disabled ? "not-allowed" : "text" }}
                />
            );
        }

        if (isCheckbox) {
            return <CustomAntCheckbox type="checkbox" />;
        }

        return null;
    };
    return (
        <TickerItemDiv
            style={{
                padding: "0 4px",
                justifyContent: editMode ? "space-between" : "flex-start",
            }}
        >
            {showDescriptions && description ? (
                <Tooltip
                    title={description}
                    placement="bottom"
                    mouseEnterDelay={0.3}
                >
                    <NameSpan style={{ cursor: "help" }}>{name}</NameSpan>
                </Tooltip>
            ) : (
                <NameSpan style={{ cursor: "default" }}>{name}</NameSpan>
            )}
            <SettingsValue $editMode={editMode}>
                {renderInput()}
                {isCheckbox && <CustomAntCheckbox type="checkbox" />}
            </SettingsValue>
            {editMode && (
                <DeleteIconArea>
                    <CustomDeleteButton onClick={() => onRemove(name)} />
                </DeleteIconArea>
            )}
        </TickerItemDiv>
    );
};
